/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class OrderService{
    private url:string = environment.host+'/transaction';
    private environemntUrl:string = environment.host

    constructor(private http: HttpClient){}
    
    public getAllOrders(){
        return this.http.get(this.url.toString()).toPromise();
    }

    public createOrder(newOrder: any){
        return this.http.post(this.url.toString(), newOrder).toPromise();
    }
    
    public getPlanPeriod(){
        return this.http.get(this.environemntUrl.toString() + '/period').toPromise();
    }

    public searchByOrder(orderId: any) {
        return this.http.get(this.environemntUrl.toString() + '/order',{params: {orderId: orderId}}).toPromise();
    }
}